export default __webpack_public_path__ + "static/media/August2013.8f8e493b.png";